import type { SVGProps } from 'react'
import * as React from 'react'
const CardLimitIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={85} height={84} fill='none' {...props}>
    <path
      fill='url(#a)'
      d='M19.418 13.603C21.199 6.458 28.436 2.11 35.58 3.892l35.577 8.87c7.145 1.782 11.493 9.018 9.712 16.163L72 64.503c-1.782 7.145-9.018 11.493-16.163 9.711l-35.578-8.87c-7.145-1.782-11.493-9.018-9.711-16.163z'
    />
    <g filter='url(#b)'>
      <path
        fill='#FFA8B0'
        fillOpacity={0.5}
        d='M.977 34c0-7.364 5.97-13.334 13.333-13.334h36.667c7.363 0 13.333 5.97 13.333 13.333v36.667c0 7.364-5.97 13.333-13.333 13.333H14.31C6.946 84 .977 78.03.977 70.666z'
      />
    </g>
    <path
      fill='#fff'
      d='M41.864 57.78a2.65 2.65 0 0 1 0 3.755c-.52.52-1.193.798-1.896.798a2.52 2.52 0 0 1-1.866-.797L32.66 56.13l-5.444 5.405c-.52.52-1.192.798-1.896.798a2.72 2.72 0 0 1-1.896-.797c-1.04-1.036-1.04-2.717 0-3.786l5.444-5.408-5.444-5.442a2.687 2.687 0 0 1 0-3.786c1.04-1.041 2.722-1.041 3.792 0l5.444 5.436 5.413-5.436c1.07-1.041 2.752-1.041 3.792 0a2.687 2.687 0 0 1 0 3.786l-5.444 5.442z'
    />
    <defs>
      <linearGradient id='a' x1={22.644} x2={77.782} y1={0.666} y2={7.798} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#ED8E98' />
        <stop offset={1} stopColor='#FF3347' />
      </linearGradient>
      <filter
        id='b'
        width={76.666}
        height={76.666}
        x={-5.69}
        y={13.999}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feGaussianBlur in='BackgroundImageFix' stdDeviation={3.333} />
        <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_3784_4904' />
        <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_3784_4904' result='shape' />
        <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
        <feOffset dx={0.333} dy={0.167} />
        <feGaussianBlur stdDeviation={0.833} />
        <feComposite in2='hardAlpha' k2={-1} k3={1} operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
        <feBlend in2='shape' result='effect2_innerShadow_3784_4904' />
      </filter>
    </defs>
  </svg>
)
export default CardLimitIcon
